import Card from '@molecules/Card';
import {
  StyledRoomCardContainer,
  StyledRoomCardGalleryContainer,
  StyledRoomInfoContainer,
} from './StyledRoomDetailCard';
import { Flex, Skeleton, SkeletonText } from '@chakra-ui/react';

const SkeletonRoomDetail = () => (
  <Card padding="0" bgColor="white">
    <StyledRoomCardContainer>
      <StyledRoomCardGalleryContainer>
        <Skeleton height="250px" />
      </StyledRoomCardGalleryContainer>
      <StyledRoomInfoContainer>
        <SkeletonText mt="4" noOfLines={1} spacing="4" width="120px" />
        <Flex gap="12px" mt={3}>
          <Skeleton width="130px" height="25px" />
        </Flex>
        <SkeletonText mt="4" noOfLines={5} spacing="4" width="100%" />
      </StyledRoomInfoContainer>
    </StyledRoomCardContainer>
  </Card>
);

export default SkeletonRoomDetail;
